import Button, { BUTTON_VARIANT } from "@/components/Common/Button";
import styles from "./CalloutBand.module.scss";

/**
 * Light callout band: heading + body + an outlined button (Figma "Request Bulk
 * Essential Oil Supply" section). Distinct from the bottom `cta` banner (which
 * is the full dark ContactUsForm). Surface-aware (default grey).
 */
export default function CalloutBand({
  heading,
  body,
  buttonText,
  buttonHref = "/contact-elchemy",
  surface = "grey",
}) {
  const paras = Array.isArray(body) ? body : body ? [body] : [];
  if (!heading && !paras.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {paras.map((p, i) => (
          <p className={styles.para} key={i}>
            {p}
          </p>
        ))}
        {/*
          Shared Button (components/Common/Button), `outline` variant. Verified
          property-by-property against the `outline-btn` mixin this replaced: 18 of
          20 declarations are byte-identical. The two additions are inert here —
          `gap: 8px` needs two flex children (this button has one text node) and
          `transition` only animates colour on hover. `font-family: inherit`
          resolves to Mukta because `section-shell` sets it on `.section`.
        */}
        {buttonText && (
          <Button variant={BUTTON_VARIANT.OUTLINE} href={buttonHref}>
            {buttonText}
          </Button>
        )}
      </div>
    </section>
  );
}
